import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { defineMessages, FormattedMessage } from 'react-intl';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  title: {
    id: 'trello.heading',
    defaultMessage:
      'Would you like to give the following application access to your account?',
    description: 'Heading for trello consent page',
  },
});

const Header = () => (
  <Box xcss={centeredContentStyles}>
    <Heading size="xlarge">
      <FormattedMessage {...messages.title} />
    </Heading>
  </Box>
);

export default Header;
